import moment from 'moment'
import React from 'react'

function BarcodeBatchListComponent({batchList,setSelectedBatch}) {
    return (
        <div className='row mt-3'>
            <div className='col-md-12'>
                <div className='card'>
                    <div className='card-header'>Barcode Batch List</div>
                    <div className='card-body'>
                        <table className='table'>
                            <thead>
                                <tr>
                                    <th>Batch Id</th>
                                    <th>Create By</th>
                                    <th>Label Count </th>
                                    <th>Created At</th>
                                    <th>Created At</th>
                                </tr>
                            </thead>
                            <tbody>
                                {batchList.map(batch=>
                                    <tr>
                                        <td>{batch.id}</td>
                                        <td>{batch.firstName} {batch.lastName}</td>
                                        <td>{batch.count}</td>
                                        <td>{ moment(batch.created_at).format("LLLL")}</td>
                                        <td><button className='btn btn-primary' onClick={()=>setSelectedBatch(batch.id)}>Print</button></td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BarcodeBatchListComponent